// TopHeader.js
import React, { useReducer, useState, useEffect, useRef, memo } from "react";
import headerStyle from "./Header.module.css";
import HeaderItem from "../ReuseableComp/HeaderItem";
import { FaRegCircleUser } from "react-icons/fa6";
import { MdOutlineNotificationsActive } from "react-icons/md";
import { TbSettings } from "react-icons/tb";
import { IoAnalyticsSharp } from "react-icons/io5";

import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { initialState, reducer } from "../Reduceres/reducer";
import {
  TOGGLE_PROFILE_DROPDOWN,
  TOGGLE_NOTIFICATION_DROPDOWN,
  TOGGLE_LIVE_STATUS_DROPDOWN,
  CLOSE_ALL_DROPDOWNS,
} from "../Reduceres/Action";
import { useSelector } from "react-redux";
import logoImg from "../img/sageion-logo.png";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { setPlanAct } from "../../redux/allAction/planActions";
import { useTrainingNotifications } from "../../hooks/useTrainingNotifications";
import { useTenantPlan } from "../../hooks/useTenantPlan";

// ============================================================
// IMPORT FEATURE FLAGS
// ============================================================
import { isFeatureEnabled } from "../../config/featureFlags"; 

const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

function registerUsersLSstatus(status) {
  const PREFIX = "[LS-STATUS]";
  console.log(PREFIX, "Function called with status:", status);

  const meData = localStorage.getItem("meData");
  console.log(PREFIX, "Raw meData:", meData);

  if (meData) {
    const meData_p = JSON.parse(meData);
    console.log(PREFIX, "Parsed meData:", meData_p);

    if (meData_p.id) {
      console.log(PREFIX, "Tenant info:", meData_p.tenant_info?.tenant);

      const body_obj = {
        live_status: status,
        tenant: meData_p.tenant_info?.tenant,
        frm_user: {
          id: meData_p.id,
        },
      };

      let bodyContent = JSON.stringify(body_obj);
      console.log(PREFIX, "body_obj:", body_obj);
      console.log(PREFIX, "bodyContent:", bodyContent);

      const emit_payload = {
        tenant_id: meData_p.id,
        ...body_obj,
      };

      console.log(PREFIX, "emit_payload:", emit_payload);

      window.MyPackage.updateMyLsPostHandler(emit_payload);

      console.log(PREFIX, "updateMyLsPostHandler called");
    } else {
      console.log(PREFIX, "No meData_p.id found");
    }
  } else {
    console.log(PREFIX, "No meData found in localStorage");
  }
}

export const FirstAppHeader = memo(({ isMobile, userInfo }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({});
  const [showAnalyticsComponent, setShowAnalyticsComponent] = useState(false);
  const [state, localDispatch] = useReducer(reducer, initialState);

  console.log("userInfoddd", userInfo);
  // Use the custom hook for notifications
  const { notifications, unreadCount, markAsRead, markAllAsRead, clearAll } =
    useTrainingNotifications();

  const dispatch = useDispatch();
  const [liveStatus, setLiveStatus] = useState("ONLINE");
  const history = useHistory();
  const headerRef = useRef(null);

  const { plan } = useTenantPlan();
  const meData = useSelector((state) => state.auth.meData);

  useEffect(() => {
    console.log("✅ meData from Redux store:", meData);
  }, [meData]);

  console.log("reetu dfdj dfkd", meData);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        localDispatch({ type: CLOSE_ALL_DROPDOWNS });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const myHanderFunc = (item, id) => {
    if (id === "analytic") {
      history.push("/analytics");
      return;
    }

    if (item === "ONLINE" || item === "OFFLINE") {
      console.log("sddddddddditemdddddddd", item);
      setLiveStatus(item);
      registerUsersLSstatus(item);
    }

    if (item === "LogOut") {
      localStorage.clear();
      window.location.reload();
    }

    if (item === "My Profile") {
      history.push("/my_profile");
    }

    if (item === "Payment & Billing") {
      history.push("/payments");
    }

    if (item === "Support") {
      history.push("/support");
    }

    if (item === "Settings") {
      history.push("/settings");
    }
  };

  // Custom notification dropdown content using hook data
  const NotificationDropdown = () => (
    <div className={headerStyle.notificationDropdown}>
      <div className={headerStyle.notificationHeader}>
        <h4>Notifications</h4>
        <div className={headerStyle.notificationActions}>
          {notifications.length > 0 && (
            <>
              <button onClick={markAllAsRead} className={headerStyle.actionBtn}>
                Mark all read
              </button>
              <button onClick={clearAll} className={headerStyle.actionBtn}>
                Clear all
              </button>
            </>
          )}
        </div>
      </div>

      <div className={headerStyle.notificationList}>
        {notifications.length === 0 ? (
          <div className={headerStyle.emptyNotifications}>
            <p>No notifications</p>
          </div>
        ) : (
          notifications.map((notification) => (
            <div
              key={notification.id}
              className={`${headerStyle.notificationItem} ${!notification.read ? headerStyle.unread : ""}`}
              onClick={() => markAsRead(notification.id)}
            >
              <div className={headerStyle.notificationIcon}>🎓</div>
              <div className={headerStyle.notificationContent}>
                <div className={headerStyle.notificationMessage}>
                  {notification.message}
                </div>
                <div className={headerStyle.notificationTime}>
                  {notification.timestamp.toLocaleTimeString()}
                </div>
                {!notification.read && (
                  <span className={headerStyle.unreadDot}></span>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );

  const UserProfileSetting = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2_2)">
        <path
          d="M11.5 12.9619C11.7387 12.9619 11.9679 13.0568 12.1367 13.2256C12.3054 13.3944 12.4004 13.6237 12.4004 13.8623C12.4003 14.1007 12.3052 14.3294 12.1367 14.498C11.9679 14.6668 11.7387 14.7617 11.5 14.7617C8.54899 14.7617 5.94095 15.4603 4.3418 16.5518C3.43986 17.1655 2.90039 17.8589 2.90039 18.6123V20.0635C2.90052 20.0766 2.90578 20.0894 2.91504 20.0986C2.92438 20.1078 2.93709 20.1133 2.9502 20.1133H11.5C11.7387 20.1133 11.9679 20.2082 12.1367 20.377C12.3052 20.5456 12.4003 20.7743 12.4004 21.0127C12.4004 21.2513 12.3054 21.4806 12.1367 21.6494C11.9679 21.8182 11.7387 21.9131 11.5 21.9131H2.9502C2.45954 21.9131 1.98854 21.718 1.6416 21.3711C1.29487 21.0243 1.09973 20.5539 1.09961 20.0635V18.6123C1.09961 17.2795 1.90804 16.0317 3.32617 15.0645C5.18377 13.7979 8.15713 12.9619 11.5 12.9619ZM17.5 13.7881L17.6904 13.793C19.6509 13.8922 21.2129 15.515 21.2129 17.5C21.2129 19.5488 19.5488 21.2129 17.5 21.2129H17.4961C16.5301 21.1849 15.6128 20.781 14.9395 20.0879C14.2663 19.3949 13.8898 18.4671 13.8896 17.501C13.8896 16.5347 14.2662 15.6062 14.9395 14.9131C15.6128 14.2199 16.5301 13.8161 17.4961 13.7881H17.5ZM17.5 15.5879C16.4447 15.5879 15.5869 16.4449 15.5869 17.5C15.5869 18.5552 16.4448 19.4131 17.5 19.4131C18.5552 19.4131 19.4131 18.5552 19.4131 17.5C19.4131 16.4449 18.5553 15.5879 17.5 15.5879ZM11.5 1.09961C14.6188 1.09961 17.1504 3.63116 17.1504 6.75C17.1504 9.86884 14.6188 12.4004 11.5 12.4004C8.38116 12.4004 5.84961 9.86884 5.84961 6.75C5.84961 3.63116 8.38116 1.09961 11.5 1.09961ZM11.5 2.90039C9.37484 2.90039 7.65039 4.62484 7.65039 6.75C7.65039 8.87516 9.37484 10.5996 11.5 10.5996C13.6252 10.5996 15.3496 8.87516 15.3496 6.75C15.3496 4.62484 13.6252 2.90039 11.5 2.90039Z"
          fill="#79787B"
          stroke="#79787B"
          stroke-width="0.3"
        />
        <path
          d="M17.5 19.4121C17.7387 19.4121 17.9679 19.507 18.1367 19.6758C18.3052 19.8444 18.4003 20.0731 18.4004 20.3115V22C18.4004 22.2387 18.3055 22.4679 18.1367 22.6367C17.9679 22.8055 17.7387 22.9004 17.5 22.9004C17.2613 22.9004 17.0321 22.8055 16.8633 22.6367C16.6945 22.4679 16.5996 22.2387 16.5996 22V20.3115C16.5997 20.0731 16.6948 19.8444 16.8633 19.6758C17.0321 19.507 17.2613 19.4121 17.5 19.4121ZM15.5117 18.5889C15.75 18.5889 15.9785 18.6835 16.1475 18.8516L16.1484 18.8525C16.3165 19.0215 16.4111 19.25 16.4111 19.4883C16.4111 19.6969 16.3387 19.8983 16.208 20.0586L16.1484 20.125L14.9541 21.3184C14.8706 21.4018 14.7712 21.4675 14.6621 21.5127C14.5531 21.5579 14.4364 21.581 14.3184 21.5811C14.2002 21.5811 14.0828 21.5579 13.9736 21.5127C13.8646 21.4675 13.7651 21.4018 13.6816 21.3184C13.5982 21.2349 13.5325 21.1354 13.4873 21.0264C13.4421 20.9172 13.4189 20.7998 13.4189 20.6816C13.419 20.5636 13.4421 20.4469 13.4873 20.3379C13.5325 20.2288 13.5982 20.1294 13.6816 20.0459L14.875 18.8516L14.9414 18.792C15.1017 18.6613 15.3031 18.5889 15.5117 18.5889ZM19.4883 18.5889C19.7268 18.5889 19.956 18.6833 20.125 18.8516L21.3184 20.0459C21.4018 20.1294 21.4675 20.2288 21.5127 20.3379C21.5579 20.4469 21.581 20.5636 21.5811 20.6816C21.5811 20.7998 21.5579 20.9172 21.5127 21.0264C21.4675 21.1354 21.4018 21.2349 21.3184 21.3184C21.2349 21.4018 21.1354 21.4675 21.0264 21.5127C20.9172 21.5579 20.7998 21.5811 20.6816 21.5811C20.5636 21.581 20.4469 21.5579 20.3379 21.5127C20.2288 21.4675 20.1294 21.4018 20.0459 21.3184L18.8516 20.125C18.6833 19.956 18.5889 19.7268 18.5889 19.4883C18.5889 19.25 18.6835 19.0215 18.8516 18.8525L18.8525 18.8516C19.0215 18.6835 19.25 18.5889 19.4883 18.5889ZM14.6865 16.5996C14.9251 16.5996 15.1545 16.6946 15.3232 16.8633C15.492 17.0321 15.5869 17.2613 15.5869 17.5C15.5869 17.7387 15.492 17.9679 15.3232 18.1367C15.1545 18.3054 14.9251 18.4004 14.6865 18.4004H13C12.7613 18.4004 12.5321 18.3055 12.3633 18.1367C12.1945 17.9679 12.0996 17.7387 12.0996 17.5C12.0996 17.2613 12.1945 17.0321 12.3633 16.8633C12.5321 16.6945 12.7613 16.5996 13 16.5996H14.6865ZM22 16.5996C22.2387 16.5996 22.4679 16.6945 22.6367 16.8633C22.8055 17.0321 22.9004 17.2613 22.9004 17.5C22.9004 17.7387 22.8055 17.9679 22.6367 18.1367C22.4679 18.3055 22.2387 18.4004 22 18.4004H20.3115C20.0731 18.4003 19.8444 18.3052 19.6758 18.1367C19.507 17.9679 19.4121 17.7387 19.4121 17.5C19.4121 17.2613 19.507 17.0321 19.6758 16.8633C19.8444 16.6948 20.0731 16.5997 20.3115 16.5996H22ZM14.3184 13.4189C14.4364 13.419 14.5531 13.4421 14.6621 13.4873C14.7712 13.5325 14.8706 13.5982 14.9541 13.6816L16.1484 14.875L16.208 14.9414C16.3387 15.1017 16.4111 15.3031 16.4111 15.5117C16.4111 15.75 16.3165 15.9785 16.1484 16.1475L16.1475 16.1484C15.9785 16.3165 15.75 16.4111 15.5117 16.4111C15.3031 16.4111 15.1017 16.3387 14.9414 16.208L14.875 16.1484L13.6816 14.9541C13.5982 14.8706 13.5325 14.7712 13.4873 14.6621C13.4421 14.5531 13.419 14.4364 13.4189 14.3184C13.4189 14.2002 13.4421 14.0828 13.4873 13.9736C13.5325 13.8646 13.5982 13.7651 13.6816 13.6816C13.7651 13.5982 13.8646 13.5325 13.9736 13.4873C14.0828 13.4421 14.2002 13.4189 14.3184 13.4189ZM20.6816 13.4189C20.9202 13.4189 21.1497 13.5129 21.3184 13.6816C21.4871 13.8503 21.5811 14.0798 21.5811 14.3184C21.581 14.5567 21.4869 14.7855 21.3184 14.9541L20.125 16.1484C19.956 16.3167 19.7268 16.4111 19.4883 16.4111C19.25 16.4111 19.0215 16.3165 18.8525 16.1484L18.8516 16.1475C18.6835 15.9785 18.5889 15.75 18.5889 15.5117C18.5889 15.2732 18.6833 15.044 18.8516 14.875L20.0459 13.6816C20.2145 13.5131 20.4433 13.419 20.6816 13.4189ZM17.5 12.0996C17.7387 12.0996 17.9679 12.1945 18.1367 12.3633C18.3055 12.5321 18.4004 12.7613 18.4004 13V14.6865C18.4005 14.9252 18.3053 15.1544 18.1367 15.3232C17.9681 15.492 17.7395 15.5876 17.501 15.5879C17.2623 15.5881 17.0331 15.4928 16.8643 15.3242C16.6955 15.1556 16.5999 14.927 16.5996 14.6885V13C16.5996 12.7613 16.6945 12.5321 16.8633 12.3633C17.0321 12.1945 17.2613 12.0996 17.5 12.0996Z"
          fill="#79787B"
          stroke="#79787B"
          stroke-width="0.3"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_2">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
  return (
    <div ref={headerRef} className={headerStyle.headerWrap}>
      <header className={headerStyle.topbar}>
        <div className={headerStyle.logo}>
          <Link to="/" className={headerStyle.logoImg}>
            <img src={logoImg} alt="logo" />
          </Link>
        

          {!isMobile && (
              <h2>
            <span className={headerStyle.sageText}>Sage</span>
            <span className={headerStyle.ionText}>ion</span>
          </h2>
          )}
        </div>

        <div className={headerStyle.profileHelp}>
          {plan == "BASIC" && (
            <Link to="/pricing" className={headerStyle.upgrade}>
              <button className={headerStyle.upgradeBtn}>Upgrade</button>
            </Link>
          )}

          {!isMobile && meData && (
            <div>
              Welcome {meData?.full_name} (
              {meData?.type == "support_type" ? "Support User" : "Admin"})
            </div>
          )}

          {/* ============================================================
              LIVE STATUS TOGGLE
              Only rendered if the `live_chat` feature flag is true
             ============================================================ */}
          {isFeatureEnabled("live_chat") && (
            <div
              style={{
                position: "relative",
                display: "inline-block",
                zIndex: 50,
              }}
            >
              <HeaderItem
                myHanderFunc={myHanderFunc}
                id="live_status"
                customIcon={
                  <FaRegCircleUser
                    style={{ fontSize: "22px", color: "#79787b" }}
                  />
                }
                text={["ONLINE", "OFFLINE"]}
                padding="7px"
                color="#333"
                isOpen={state.liveStatusDropdownOpen}
                toggleDropdown={() =>
                  localDispatch({ type: TOGGLE_LIVE_STATUS_DROPDOWN })
                }
              />
              <span
                style={{
                  position: "absolute",
                  top: "2px",
                  right: "4px",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor:
                    liveStatus === "ONLINE" ? "#00D26A" : "#FF4B4B",
                  border: "2px solid white",
                  boxShadow: "0 0 4px rgba(0,0,0,0.3)",
                  zIndex: 100,
                }}
              ></span>
            </div>
          )}

          {/* Notification Bell with Counter */}
          <div style={{ position: "relative", display: "inline-block" }}>
            <HeaderItem
              myHanderFunc={myHanderFunc}
              id="notification"
              customIcon={
                <MdOutlineNotificationsActive
                  style={{ fontSize: "26px", color: "#79787b" }}
                />
              }
              text={[]}
              padding="4px"
              color="#333"
              isOpen={state.notificationDropdownOpen}
              toggleDropdown={() =>
                localDispatch({ type: TOGGLE_NOTIFICATION_DROPDOWN })
              }
            >
              {/* Custom dropdown content as children */}
              <NotificationDropdown />
            </HeaderItem>

            {/* Notification Counter Badge */}
            {unreadCount > 0 && (
              <span className={headerStyle.notificationBadge}>
                {unreadCount > 99 ? "99+" : unreadCount}
              </span>
            )}
          </div>

          <HeaderItem
            id="analytic"
            myHanderFunc={myHanderFunc}
            customIcon={
              <IoAnalyticsSharp
                style={{ fontSize: "26px", color: "#79787b" }}
              />
            }
            text={[]}
            padding="4px"
            color="#333"
            isOpen={false}
            toggleDropdown={() => {}}
          />

          <HeaderItem
            myHanderFunc={myHanderFunc}
            id="user"
            customIcon={
              <UserProfileSetting
                style={{ fontSize: "26px", color: "#79787b" }}
              />
            }
            text={[
              "My Profile",
              "Payment & Billing",
              "Support",
              "Settings",
              "LogOut",
            ]}
            padding="4px"
            color="#333"
            isOpen={state.profileDropdownOpen}
            toggleDropdown={() =>
              localDispatch({ type: TOGGLE_PROFILE_DROPDOWN })
            }
          />
        </div>
      </header>

      {(state.notificationDropdownOpen ||
        state.profileDropdownOpen ||
        state.analyticsDropdownOpen ||
        state.liveStatusDropdownOpen) && (
        <div
          onClick={() => localDispatch({ type: CLOSE_ALL_DROPDOWNS })}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "transparent",
          }}
        />
      )}
    </div>
  );
});